module.exports = __webpack_public_path__ + "img/foreward_2.d198d39f.jpg";